import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import { BaseUrl } from "../../helper/BaseUrl";
import CustomSelect from "../../component/CustomSelect";
import CustomImageUpload from "../../component/CustomImageUpload";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const dynamicEditEndpoint = ApiEndpoints.dynamicPage.dynamicEdit;
const dynamicUpdateEndpoint = ApiEndpoints.dynamicPage.dynamicUpdate;

export default function EditDynamic() {
  const navigate = useNavigate();
  const { dynamicpage_id } = useParams();

  const [previews, setPreviews] = useState({ section1_image: null, section3_point1_icon: null, section3_point2_icon: null, section3_point3_icon: null, section3_point4_icon: null, section3_point5_icon: null, section3_point6_icon: null, section6_image: null });

  const [postData, setPostData] = useState({
    // date: new Date(),
    slug: "",
    section1_title: "",
    section1_description: "",
    section1_image: null,
    section2_red_heading: "",
    section2_main_heading: "",
    section2_description: "",
    section3_heading: "",
    section3_point1_icon: null,
    section3_point1_heading: "",
    section3_point1_description: "",
    section3_point2_icon: null,
    section3_point2_heading: "",
    section3_point2_description: "",
    section3_point3_icon: null,
    section3_point3_heading: "",
    section3_point3_description: "",
    section3_point4_icon: null,
    section3_point4_heading: "",
    section3_point4_description: "",
    section3_point5_icon: null,
    section3_point5_heading: "",
    section3_point5_description: "",
    section3_point6_icon: null,
    section3_point6_heading: "",
    section3_point6_description: "",
    section4_heading: "",
    section4_stat1_count: "",
    section4_stat1_description: "",
    section4_stat2_count: "",
    section4_stat2_description: "",
    section4_stat3_count: "",
    section4_stat3_description: "",
    section4_stat4_count: "",
    section4_stat4_description: "",
    section5_heading: "",
    section5_description: "",
    section6_image: null,
    section6_heading: "",
    section6_red_heading: "",
    section6_description: "",
    section8_heading: "",
    section8_description: "",
    section8_testimonial1: "",
    section8_testimonial1_author: "",
    section8_testimonial2: "",
    section8_testimonial2_author: "",
    section8_testimonial3: "",
    section8_testimonial3_author: "",
    faqs: [
      {
        question: "",
        answer: ""
      }
    ],
  });



  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ApiRequest("GET", `${dynamicEditEndpoint}${dynamicpage_id}`,);
        setPostData(response.dynamicpage);
        setPreviews((prev) => ({
          ...prev,
          section1_image: BaseUrl + response.dynamicpage.section1_image || prev.section1_image,
          section3_point1_icon: BaseUrl + response.dynamicpage.section3_point1_icon || prev.section3_point1_icon,
          section3_point2_icon: BaseUrl + response.dynamicpage.section3_point2_icon || prev.section3_point2_icon,
          section3_point3_icon: BaseUrl + response.dynamicpage.section3_point3_icon || prev.section3_point3_icon,
          section3_point4_icon: BaseUrl + response.dynamicpage.section3_point4_icon || prev.section3_point4_icon,
          section3_point5_icon: BaseUrl + response.dynamicpage.section3_point5_icon || prev.section3_point5_icon,
          section3_point6_icon: BaseUrl + response.dynamicpage.section3_point6_icon || prev.section3_point6_icon,
          section6_image: BaseUrl + response.dynamicpage.section6_image || prev.section6_image,
        }));


      } catch (error) {
        console.error("Error fetching blog data:", error);
      }
    };

    fetchData();
  }, [dynamicpage_id]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];

      // Update the previews state
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(file),
      }));

      // Update the postData state
      setPostData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      let updatedValue = value;
      if (name === "date") {
        updatedValue = new Date(value).toISOString();
      }
      setPostData((prev) => ({
        ...prev,
        [name]: updatedValue,
      }));
    }
  };

  const handleEditorChange = (key, data) => {
    setPostData((prevState) => ({
      ...prevState,
      [key]: data,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const [key, value] of Object.entries(postData)) {
      if ((value === "" || value === null)) {
        toast.error(`The field "${key}" is mandatory.`);
        return;
      }
    }
    const formData = new FormData();
    Object.entries(postData).forEach(([key, value]) => {
      if (key === "faqs") {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, value);
      }
    });

    try {
      const response = await ApiRequest("POST", dynamicUpdateEndpoint + dynamicpage_id, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.error === true) {
        toast.error(response.message);  
      } else {
        toast.success(response.message);
      }
      // toast.success(response.message);
      navigate("/dynamic");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  // 🔹 handle change for question/answer
  const handleFaqChange = (index, field, value) => {
    setPostData((prev) => {
      const updatedFaqs = [...prev.faqs];
      updatedFaqs[index][field] = value;
      return { ...prev, faqs: updatedFaqs };
    });
  };

  // 🔹 add new FAQ
  const addFaq = () => {
    setPostData((prev) => ({
      ...prev,
      faqs: [...prev.faqs, { question: "", answer: "" }],
    }));
  };

  // 🔹 remove FAQ
  const removeFaq = (index) => {
    setPostData((prev) => ({
      ...prev,
      faqs: prev.faqs.filter((_, i) => i !== index),
    }));
  };

  const pagename = {
    name: 'Dynamic Management',
    user: 'Admin',
    innerpage: 'Dynamic Management / Dynamic / Edit Dynamic'
  }

  return (
    <>

      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <form id="dynamicEditAdd" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <h5>Section 1 </h5>
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} value={postData?.section1_title} name="section1_title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>slug<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="slug" value={postData?.slug} type="text" className="form-control" placeholder="Enter Slug" />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Description<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section1_description" value={postData?.section1_description} type="text" className="form-control" placeholder="Enter description" />
                </div>
              </div>
              {/* <div className="col-lg-6">
                    <div className="add-page-inputs">
                      <div className="label-wrap-add">
                        <label>Date<small>*</small></label>
                      </div>
                      <input onChange={handleChange} name="date" type="date" className="form-control" placeholder="date" />
                    </div>
                  </div> */}
              <div className="col-lg-12">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Banner Image (960 × 804)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="section1_image"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section1_image}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <h5>Section 2 </h5>
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Subtitle<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section2_red_heading" value={postData?.section2_red_heading} type="text" className="form-control" placeholder="Enter Sub Title" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section2_main_heading" value={postData?.section2_main_heading} type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.section2_description} onChange={(event, editor) => handleEditorChange("section2_description", editor.getData())} />
                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <h5>Section 3 </h5>
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Main Heading <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section3_heading" value={postData?.section3_heading} type="text" className="form-control" placeholder="Enter Main Heading" />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label> Icon (80 × 80)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="section3_point1_icon"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section3_point1_icon}
                  />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section3_point1_heading" value={postData?.section3_point1_heading} type="text" className="form-control" placeholder="Enter Title" />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Description<small>*</small></label>
                  </div>

                  <input onChange={handleChange} name="section3_point1_description" value={postData?.section3_point1_description} type="text" className="form-control" placeholder="Enter Description" />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label> Icon (80 × 80)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="section3_point2_icon"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section3_point2_icon}
                  />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section3_point2_heading" value={postData?.section3_point2_heading} type="text" className="form-control" placeholder="Enter Title" />
                </div>


                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Description<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section3_point2_description" value={postData?.section3_point2_description} type="text" className="form-control" placeholder="Enter Description" />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label> Icon (80 × 80)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="section3_point3_icon"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section3_point3_icon}
                  />
                </div>


                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section3_point3_heading" value={postData?.section3_point3_heading} type="text" className="form-control" placeholder="Enter Title" />
                </div>


                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Description<small>*</small></label>
                  </div>

                  <input onChange={handleChange} name="section3_point3_description" value={postData?.section3_point3_description} type="text" className="form-control" placeholder="Enter Description" />
                </div>
              </div>



              <div className="col-lg-4">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label> Icon (80 × 80)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="section3_point4_icon"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section3_point4_icon}
                  />
                </div>


                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section3_point4_heading" value={postData?.section3_point4_heading} type="text" className="form-control" placeholder="Enter Title" />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Description<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section3_point4_description" value={postData?.section3_point4_description} type="text" className="form-control" placeholder="Enter Description" />
                </div>

              </div>
              <div className="col-lg-4">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label> Icon (80 × 80)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="section3_point5_icon"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section3_point5_icon}
                  />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section3_point5_heading" value={postData?.section3_point5_heading} type="text" className="form-control" placeholder="Enter Title" />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Description<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section3_point5_description" value={postData?.section3_point5_description} type="text" className="form-control" placeholder="Enter Description" />
                </div>

              </div>


              <div className="col-lg-4">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label> Icon (80 × 80)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="section3_point6_icon"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section3_point6_icon}
                  />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section3_point6_heading" value={postData?.section3_point6_heading} type="text" className="form-control" placeholder="Enter Title" />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Description<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section3_point6_description" value={postData?.section3_point6_description} type="text" className="form-control" placeholder="Enter Description" />
                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <h5>Section 4 </h5>
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Main Heading<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section4_heading" value={postData?.section4_heading} type="text" className="form-control" placeholder="Enter Main Heading" />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Counter Number <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section4_stat1_count" value={postData?.section4_stat1_count} type="number" className="form-control" placeholder="Enter Counter Number " />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Counter Description<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section4_stat1_description" value={postData?.section4_stat1_description} type="text" className="form-control" placeholder="Enter Description" />
                </div>
              </div>
              <div className="col-lg-3">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Counter Number <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section4_stat2_count" value={postData?.section4_stat2_count} type="number" className="form-control" placeholder="Enter Counter Number " />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Counter Description<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section4_stat2_description" value={postData?.section4_stat2_description} type="text" className="form-control" placeholder="Enter Description" />
                </div>
              </div>

              <div className="col-lg-3">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Counter Number <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section4_stat3_count" value={postData?.section4_stat3_count} type="number" className="form-control" placeholder="Enter Counter Number " />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Counter Description<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section4_stat3_description" value={postData?.section4_stat3_description} type="text" className="form-control" placeholder="Enter Description" />
                </div>
              </div>

              <div className="col-lg-3">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Counter Number <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section4_stat4_count" value={postData?.section4_stat4_count} type="number" className="form-control" placeholder="Enter Counter Number " />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Counter Description<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section4_stat4_description" value={postData?.section4_stat4_description} type="text" className="form-control" placeholder="Enter Description" />
                </div>
              </div>

            </div>
          </div>
          <div className="add-content-wrap">
            <h5>Section 5 </h5>
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Heading<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section5_heading" value={postData?.section5_heading} type="text" className="form-control" placeholder="Enter Sub Title" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section5_description" value={postData?.section5_description} type="text" className="form-control" placeholder="Enter Description" />
                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <h5>Section 6 </h5>
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Heading <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section6_heading" value={postData?.section6_heading} type="text" className="form-control" placeholder="Enter  Heading" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Red Sub Title <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section6_red_heading" value={postData?.section6_red_heading} type="text" className="form-control" placeholder="Enter Red Sub Title" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.section6_description} onChange={(event, editor) => handleEditorChange("section6_description", editor.getData())} />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Image Image(780*914) <small>*</small></label>
                  </div>

                  <CustomImageUpload name="section6_image"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section6_image} />
                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <h5>Section 8 </h5>
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Main Heading <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section8_heading" value={postData?.section8_heading} type="text" className="form-control" placeholder="Enter  Heading" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section8_description" value={postData?.section8_description} type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Testimonial Heading<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section8_testimonial1" value={postData?.section8_testimonial1} type="text" className="form-control" placeholder="Enter  Heading" />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Testimonial  Author Name<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section8_testimonial1_author" value={postData?.section8_testimonial1_author} type="text" className="form-control" placeholder="Enter  Author" />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Testimonial Heading<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section8_testimonial2" value={postData?.section8_testimonial2} type="text" className="form-control" placeholder="Enter  Heading" />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Testimonial  Author Name<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section8_testimonial2_author" value={postData?.section8_testimonial2_author} type="text" className="form-control" placeholder="Enter  Author" />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Testimonial Heading<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section8_testimonial3" value={postData?.section8_testimonial3} type="text" className="form-control" placeholder="Enter  Heading" />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Testimonial  Author Name<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section8_testimonial3_author" value={postData?.section8_testimonial3_author} type="text" className="form-control" placeholder="Enter  Author" />
                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <h5>Faq Section</h5>
            <div className="row">

              {postData.faqs.map((faq, index) => (
                <div key={index} className="col-lg-6" style={{ position: "relative" }}>
                  <div className="add-page-inputs input-add-image">
                    <div className="label-wrap-add">
                      <label>Question<small>*</small></label>
                    </div>
                    <input required className="form-control" type="text" placeholder={`Question ${index + 1}`} value={faq.question} onChange={(e) => handleFaqChange(index, "question", e.target.value)} />
                  </div>

                  <div className="add-page-inputs input-add-image">
                    <div className="label-wrap-add">
                      <label>Answer<small>*</small></label>
                    </div>
                    <input required className="form-control" placeholder={`Answer ${index + 1}`}
                      value={faq.answer} onChange={(e) => handleFaqChange(index, "answer", e.target.value)} />
                  </div>
                  {index >= 2 && (
                    <button type="button" className="remove-btn" onClick={() => removeFaq(index)}>
                      REMOVE
                    </button>
                  )}
                </div>
              ))}

              <div className="col-lg-12 text-center">
                <div className="add-more-btn">
                  <button type="button" className="add-faqs add-faqs addmore-images-client" onClick={addFaq} >
                    Add More Faq
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
        <button type="submit" form="dynamicEditAdd" className="default-btn">Publish <span></span></button>
      </div>

    </>
  );
}



